import AdvancedController from "../lib/advanced-controller"
import { gsap } from 'gsap';
// import ScrollTrigger from "gsap/ScrollTrigger";

// gsap.registerPlugin(ScrollTrigger);

export default class Scene05Controller extends AdvancedController {

  static targets = [
    "container",
    "award"
  ];

  static values = {
  }

  connect() {
    super.connect();

    const BASE_ANIMATION_TIME = 1;

    this.timeline = gsap.timeline({

      onUpdate: this.onUpdate.bind(this),
      scrollTrigger: {
        start: "-64px top",
        pin: this.containerTarget,
        end: "1600%",
        scrub: 0.5,
        // markers: { startColor: "green", endColor: "red", fontSize: "12px" }
      }
    });

    const randomAngles = []
    for (let index = 0; index < this.awardTargets.length; index++) {
      const vec2d = [1 - Math.random() * 2, 1 - Math.random() * 2]
      const l = Math.sqrt(vec2d[0] * vec2d[0] + vec2d[1] * vec2d[1])
      vec2d[0] = vec2d[0] / l
      vec2d[1] = vec2d[1] / l
      randomAngles.push(vec2d)
    }

    const scaleFactor = window.innerWidth > 767 ? 4 : 2.5

    let introAnimProps = { filter: "blur(0px)", opacity: 1, duration: 0.75 * BASE_ANIMATION_TIME, ease: "none" }
    let outroAnimProps = { filter: "blur(40px)", opacity: 0, duration: BASE_ANIMATION_TIME, ease: "none" }
    if (window.innerWidth < 992) {
      introAnimProps.filter = "blur(0px)";
      introAnimProps.opacity = 1;

      outroAnimProps.filter = "blur(0px)";
      outroAnimProps.opacity = 0;
    }

    let i = 0;
    for (const award of this.awardTargets) {
      const vec2d = randomAngles[i];
      let t = gsap.timeline()
        .to(award, { x: `${vec2d[0] * 50}vw`, y: `${vec2d[1] * 50}vh`, scale: scaleFactor, duration: 3 * BASE_ANIMATION_TIME, ease: "none", display: "none" }, 0)
        .to(award, introAnimProps, 0)
        .to(award, outroAnimProps, 1.5 * BASE_ANIMATION_TIME)
      this.timeline.add(t, "<33%")
      i += 1
    }

    const pauseTimeline = gsap.timeline()
      .to(document.body, { opacity: 1, duration: 0.5 * BASE_ANIMATION_TIME })

    this.timeline.add(pauseTimeline)

  }

  onUpdate() {
    this.sendMessage(this.debugController, 'messageProgress', this.timeline.progress())
  }

  messageDebugInit(debugController) {
    this.debugController = debugController
    this.hasDebugController = true
  }

  messageProgress(progress) {
    this.timeline.pause();
    this.timeline.progress(progress)
  }

  messageTogglePlayPause() {
    if (this.timeline.paused()) {
      this.timeline.play();
    } else {
      this.timeline.pause();
    }
  }

}
